<template>
    <CompassDialog
        :visible.sync="showModal"
        size="small"
        :title="$t.__('documents.DocChangeByCreditNote.edit_credit_note')"
        class="doc-change-by-credit-note"
        @closed="$emit('update:visible', false)"
    >
        <template slot="default">
            <div class="dialog__default">
                <p class="typographies-paragraph-medium-regular">
                    {{
                        $l10n.__(
                            "Vous allez modifier cette facture par la création d'un avoir et d'une autre facture.",
                        )
                    }}
                </p>
                <p class="typographies-paragraph-medium-regular">
                    {{
                        $l10n.__(
                            "L'avoir va se créer automatiquement et vous serez ensuite redirigé vers la nouvelle facture.",
                        )
                    }}
                </p>
            </div>
        </template>
        <template slot="footer">
            <div class="dialog__footer">
                <CompassButton
                    :label="$t.__('common.actions.cancel')"
                    type="secondary"
                    @click="$emit('update:visible', false)"
                />
                <CompassButton
                    :label="$t.__('documents.DocChangeByCreditNote.create_credit_note_and_invoice')"
                    type="primary"
                    :loading="loading"
                    class="ml-3"
                    @click="cancel"
                />
            </div>
        </template>
    </CompassDialog>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
const { mapState } = createNamespacedHelpers('documentOverview');

export default {
    data() {
        return {
            showModal: true,
            loading: false,
        };
    },
    computed: {
        ...mapState({
            docid: (state) => state.docid,
            rateCategoryId: (state) => state.rateCategoryId,
            thirdId: (state) => state.thirdId,
            layoutId: (state) => state.layoutId,
            langId: (state) => state.langId,
        }),
    },
    methods: {
        cancel: function () {
            this.loading = true;

            this.$store
                .dispatch('documentOverview/cancelInvoiceByCreditnote')
                .then(() => {
                    location.assign(
                        '?_f=invoiceForm&rateCategory=' +
                            this.rateCategoryId +
                            '&for=' +
                            this.thirdId +
                            '&copyFrom=' +
                            this.docid +
                            '&afterInvoiceChangeByCreditnote=Y' +
                            '&updatePrices=N' +
                            '&doclayout=' +
                            this.layoutId +
                            '&doclang=' +
                            this.langId +
                            '&applyThirdPrefs=N',
                    );
                })
                .catch(() => (this.loading = false));
        },
    },
};
</script>

<style lang="scss">
.doc-change-by-credit-note {
    .dialog {
        &__default {
            padding-bottom: 24px;
            p {
                margin: 0;
                &:first-child {
                    margin-bottom: var(--spacing-3);
                }
            }
        }

        &__footer {
            display: flex;
            justify-content: flex-end;
            padding: 0 32px 24px 32px;
        }
    }
}
</style>
